import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { AucEntryPointComponent } from "@auction-ui/entryPoint/entry.point.component";

@NgModule({
  declarations: [
    AucEntryPointComponent
  ],
  exports: [
    AucEntryPointComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
  ],
})
export class AucEntryPointModule { }